import { pageState } from 'Pages/AbTestList/recoil/state/page'
import {
  messagesState,
  paginationState,
  searchState
} from 'Pages/AbTestList/recoil/state/search'
import {
  messageDetailsState,
  modalDeleteState,
  modalRecoverState,
  resultsState,
  rowState
} from 'Pages/AbTestList/recoil/state/results'
import { logAppError } from 'Helpers/logger'
import getIntl from 'Helpers/intl'
import {
  deleteAbTest,
  getABTestList,
  getAggregateReport,
  getFailedSendings,
  getMessageMinimumDetails,
  getMessagesList,
  getRecoverable,
  updateRecover
} from '../actions/actions'
import {
  toastShow,
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_WARNING
} from 'mailup-web-components'
import { ABTEST_LIST_TYPE_MANUAL, ABTEST_SENDING_TYPE_WINNING } from 'Constants'
import {
  ABTEST_STATUS_COMPLETED,
  ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED,
  ABTEST_STATUS_STOP_DURING_WINNER,
  ABTEST_STATUS_WINNER_MESSAGE_DEFINED,
  ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
  ABTEST_STATUS_STOP_DURING_TEST,
  ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED
} from 'Api/beABTestApi'

export const searchTestsCallback = ({ snapshot, set, reset }) => async (
  init = false
) => {
  const searchParams = await snapshot.getPromise(searchState)
  const { pageNum, pageSize } = await snapshot.getPromise(paginationState)
  const { items: oldItems } = await snapshot.getPromise(resultsState)

  if (init) {
    // caricamento di pagina
    set(pageState, prev => ({
      ...prev,
      loaded: false,
      loading: true,
      error: false
    }))
  } else {
    set(pageState, prev => ({
      ...prev,
      fetchingResults: true,
      error: false
    }))
  }

  try {
    const params = {
      nome: searchParams.searchText,
      tags: searchParams.filterTags,
      stato: searchParams.filterStatus,
      tipo: searchParams.filterType,
      messages: searchParams.filterMessages,
      orderBy: searchParams.orderBy,
      orderDesc: searchParams.orderDesc,
      pageNum,
      pageSize
    }
    const res = await getABTestList(params)
    const ids = []
    const aggregateReportArray = []
    const recoverableArray = []

    for (let i = 0; i < res.Items.length; i++) {
      if (
        [
          ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED,
          ABTEST_STATUS_STOP_DURING_TEST,
          ABTEST_STATUS_WINNER_MESSAGE_DEFINED,
          ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
          ABTEST_STATUS_COMPLETED,
          ABTEST_STATUS_STOP_DURING_WINNER,
          ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED
        ].includes(res.Items[i].Info.Stato)
      ) {
        aggregateReportArray.push(
          getAggregateReport(res.Items[i].Info.ABTestID)
        )
      }

      recoverableArray.push(getRecoverable(res.Items[i].Info.ABTestID))

      const messages = res.Items[i].Messages
      let countM = 0
      for (let j = 0; j < messages.length; j++) {
        if (
          messages[j].TipoInvio !== ABTEST_SENDING_TYPE_WINNING ||
          [
            ABTEST_STATUS_WINNER_MESSAGE_DEFINED,
            ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED,
            ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
            ABTEST_STATUS_COMPLETED,
            ABTEST_STATUS_STOP_DURING_WINNER
          ].includes(res.Items[i].Info.Stato) ||
          (res.Items[i].Info.TipoTest === ABTEST_LIST_TYPE_MANUAL &&
            res.Items[i].Info.Stato !== 13)
        ) {
          // visualizzato nella row
          messages[j].messageOk = true
          countM++
          // aggiungo per sendingfailedIds
          messages[j].IdInvio !== null &&
            messages[j].IdInvio !== 0 &&
            ids.push(messages[j].IdInvio)
        } else {
          // non visualizzato nella row
          messages[j].messageOk = false
        }
      }
      // reset dello stato della row con il nuovo count e i valori di default
      set(rowState(res.Items[i].Info.ABTestID), prev => ({
        ...prev,
        numberOfMessage: countM,
        titleLoaded: false,
        detailsCount: -1,
        numberOfMessageLoaded: 0,
        messageState: []
      }))
    }

    const r = await Promise.all(aggregateReportArray.concat(recoverableArray))
    res.Items.forEach(e => {
      const reportID = r.find(
        x => x.type === 'aggregate' && x.idAbTest === e.Info.ABTestID
      )
      e.aggregateReport =
        reportID && reportID.AggregateReportId
          ? { AggregateReportId: reportID.AggregateReportId }
          : null
      const recoverableVal = r.find(
        x => x.type === 'recoverable' && x.idAbTest === e.Info.ABTestID
      )
      e.recoverable = recoverableVal ? recoverableVal.value : null
    })

    let sendingfailedIds = []
    if (ids.length > 0) {
      const failedIds = await getFailedSendings(ids)
      sendingfailedIds = failedIds ? failedIds.Value : []
    }

    set(resultsState, prev => ({
      ...prev,
      items: res.Items,
      totalItems: res.TotalItems,
      searchParams: searchParams,
      sendingfailedIds
    }))
    set(pageState, prev => ({
      ...prev,
      loaded: true
    }))
    // pulizia messaggi vecchi
    oldItems.length > 0 &&
      oldItems.forEach(e => {
        e.Messages.forEach(x => {
          reset(messageDetailsState(x.IdMessaggio))
        })
      })
  } catch (error) {
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  if (init) {
    set(pageState, prev => ({
      ...prev,
      loading: false
    }))
  } else {
    set(pageState, prev => ({
      ...prev,
      fetchingResults: false
    }))
  }
}

export const getMessagesDetailsCountCallback = ({ set, snapshot }) => async (
  messages,
  idAbTest
) => {
  const { messageState } = await snapshot.getPromise(rowState(idAbTest))
  let dtCount = 0
  for (let i = 0; i < messageState.length; i++) {
    if (
      messages.find(e => e.IdMessaggio === messageState[i].idMessage)
        .TipoInvio !== ABTEST_SENDING_TYPE_WINNING &&
      messageState[i].subject === null
    ) {
      dtCount++
    }
  }

  set(rowState(idAbTest), prev => ({
    ...prev,
    detailsCount: dtCount
  }))
}

export const getMessagesSubjectCallback = ({ set, snapshot }) => async (
  idMessage,
  idAbTest
) => {
  set(messageDetailsState(idMessage), prev => ({
    ...prev,
    loading: true,
    loaded: false
  }))
  try {
    const res = await getMessageMinimumDetails(idMessage)
    set(messageDetailsState(idMessage), prev => ({
      ...prev,
      subject: res ? res.Subject : null,
      loading: false,
      loaded: true
    }))

    const updateMessageState = s => {
      const resItems = s.slice(0)
      resItems.push({
        idMessage,
        idAbTest,
        loaded: true,
        subject: res ? res.Subject : null
      })
      return resItems
    }

    set(rowState(idAbTest), prev => ({
      ...prev,
      numberOfMessageLoaded: prev.numberOfMessageLoaded + 1,
      messageState: updateMessageState(prev.messageState)
    }))
  } catch (error) {
    logAppError({
      appError: error
    })
    set(messageDetailsState(idMessage), prev => ({
      ...prev,
      subject: null,
      loading: false,
      loaded: true
    }))
  }
}

export const resetSearchCallback = ({ reset, set, snapshot }) => async () => {
  reset(searchState)
  reset(resultsState)
  reset(paginationState)
  const { items } = await snapshot.getPromise(resultsState)
  items.length > 0 &&
    items.forEach(e => {
      reset(rowState(e.Info.ABTestID))
      e.Messages.forEach(x => {
        reset(messageDetailsState(x.IdMessaggio))
      })
    })
  set(pageState, prev => ({
    ...prev,
    loaded: false
  }))
}

export const deleteABTestCallback = ({ reset, set, snapshot }) => async () => {
  const modalParams = await snapshot.getPromise(modalDeleteState)
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))
  let res
  try {
    res = await deleteAbTest(modalParams.idABTest)
    if (!res) {
      toastShow(
        getIntl().formatMessage({ id: 'Load.AbTest.AbTestDeleteWarning' }),
        TOAST_VARIANT_WARNING,
        'deleteABTestCallbackKO'
      )
    } else {
      toastShow(
        getIntl().formatMessage({ id: 'Load.AbTest.AbTestDeleteSucces' }),
        TOAST_VARIANT_SUCCESS,
        'deleteABTestCallbackOK'
      )
    }

    reset(modalDeleteState)
  } catch (error) {
    set(pageState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(pageState, prev => ({
    ...prev,
    fetchingResults: false
  }))
  return res
}

export const recoverABTestCallback = ({ reset, set, snapshot }) => async () => {
  const modalParams = await snapshot.getPromise(modalRecoverState)
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  try {
    const res = await updateRecover(modalParams.idABTest)
    if (res) {
      toastShow(
        getIntl().formatMessage({ id: 'Load.AbTest.RecoverABTestSucces' }),
        TOAST_VARIANT_SUCCESS,
        'recoverABTestCallbackOK'
      )
    } else {
      toastShow(
        getIntl().formatMessage({ id: 'Load.AbTest.recoverABTestWarning' }),
        TOAST_VARIANT_WARNING,
        'recoverABTestCallbackKO'
      )
    }

    reset(modalRecoverState)
  } catch (error) {
    set(pageState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(pageState, prev => ({
    ...prev,
    fetchingResults: false
  }))
}

export const filterMessagesCallback = ({ set, snapshot }) => async filterBy => {
  set(messagesState, prev => ({
    ...prev,
    loading: true
  }))
  const { items, count } = await getMessagesList(filterBy, 'LastUpdated DESC')
  set(messagesState, prev => ({
    ...prev,
    loading: false,
    items,
    count
  }))
}
